const STORYBOOK_TITLES = Object.freeze({
  pages: 'Pages',
  layouts: 'Layouts',
  shared: 'Shared',
  containers: 'Containers',
});

export { STORYBOOK_TITLES };
